<template>

    <div class="labels">
        <span class="label-badge" v-for="label in labels" :key="label.id" :style="badgeStyle(label)">
            <dmb-asset v-if="label.showIcon !== false && label.iconAssetId" class="label-icon" :asset-id="label.iconAssetId" stuffed></dmb-asset>
            <dmb-widget-styled-text v-if="label.showText !== false" class="label-name" :style="textStyle">{{ label.name }}</dmb-widget-styled-text>
        </span>
    </div>

</template>

<script>

import { Vue, Options } from 'vue-class-component'

import WidgetStyledText from '../WidgetStyledText.vue';
import Asset from '../ui/Asset.vue';
import { labelBackgroundStyle } from '../../util/labelDisplay';

export default Options({
    name: 'dmb-label-badges',
    components: {
        [WidgetStyledText.name]: WidgetStyledText,
        [Asset.name]: Asset
    },
    props: {
        labels: Array,
        textStyle: Object,
        imageSize: Number
    }
})(
    class LabelBadges extends Vue {

        badgeStyle(label){

            const style = labelBackgroundStyle(label, label.showBackground !== false);
            const size = (this.textStyle && this.textStyle.size) || 100;
            style['--label-size'] = size;
            style['--label-image-size'] = this.imageSize || size;
            return style;
        }
    }
)

</script>
